<template>
  <span v-if="isValidDate">
    {{ formattedDate }}
  </span>
  <span v-else-if="emptyValueText" :class="[emptyValueClass || 'gu-datagrid-empty-value']">
    {{ emptyValueText }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

import { formatDate } from '@shared/utils/date'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const params = computed(() => props.params || {})
const rawValue = computed(() => params.value?.value)
const format = computed(() => params.value?.format || 'MM/DD/YYYY')
const emptyValueText = computed(() => params.value?.emptyValueText)
const emptyValueClass = computed(() => params.value?.emptyValueClass)

const hasValue = computed(() => rawValue.value !== null && rawValue.value !== undefined && rawValue.value !== '')
const isValidDate = computed(() => {
  if (!hasValue.value) return false
  const parsed = rawValue.value instanceof Date ? rawValue.value : new Date(rawValue.value)
  return !Number.isNaN(parsed.getTime())
})

const formattedDate = computed(() => (isValidDate.value ? formatDate(rawValue.value, format.value) : ''))
</script>
